// Captures this visit's session touch once, from the first URL of the page load
// (composables/useSessionTouch.ts). Memory only: nothing is written to cookies or
// browser storage, and nothing is sent until a lead form is submitted.
import { isEmbedPath } from '~/data/tool-embeds.mjs';

export default defineNuxtPlugin(() => {
  // Embedded calculators sit in other sites' iframes: no lead forms, no touch.
  if (isEmbedPath(window.location.pathname)) return;
  captureSessionTouch(window.location.href, document.referrer);
});
